// extracted by mini-css-extract-plugin
export var integrationButton = "_4x-0";